import dateMaker from "../global/dateMaker";
import '../../styles/results.css';

export default function Table({data}) {
    return data && (
        <table>
            <thead>
                <tr>
                    <th>Data</th>
                    <th>Telefon</th>
                    <th>Email</th>
                    <th>Zaakceptowany</th>
                </tr>
            </thead>
            <tbody>
                { data.map((item, index) => (
                    <tr key={index}>
                        <td>{dateMaker(item.date)}</td>
                        <td>{item.phone ? '✔️' : '✖️'}</td>
                        <td>{item.mail ? '✔️' : '✖️'}</td>
                        <td>nie</td>
                    </tr>
                )) }
            </tbody>
        </table>
    )
}